import { getCategories } from "@/api/common"

const actions = {
  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY")
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit("UPDATE_USER_INFO", payload)
  },
  updateUserProfile({ commit }, payload) {
    commit("UPDATE_USER_PROFILE", payload)
  },
  async fetchCategories({ commit }) {
    try {
      const { data } = await getCategories()
      commit("SET_CATEGORIES", data)
      return data
    } catch (error) {
      console.error("fetchCategories failed:", error)
      throw error
    }
  },
}

export default actions
